import { render, staticRenderFns } from "./SemiologiaGastroentereologica.vue?vue&type=template&id=8001a4ac"
import script from "./SemiologiaGastroentereologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaGastroentereologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports